import { Component, Input, OnDestroy, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';
import utils from 'src/app/utils/utils';

@Component({
  selector: 'custom-dropdown-accesor',
  templateUrl: './custom-dropdown-accesor.component.html',
  styleUrls: ['./custom-dropdown-accesor.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(()=> CustomDropdownAccesorComponent),
      multi: true
    }
  ]
})
export class CustomDropdownAccesorComponent implements ControlValueAccessor, OnDestroy {
  disabled: boolean = false;
  subscriptions: Subscription[] = [];
  value = new FormControl(['', [], []]);
  @Input() form?: FormGroup;
  @Input() inputName?: string;

  @Input() data!: any;
  @Input() label!: any;
  @Input() placeholder?: string;
  @Input() filterBy?: string;
  @Input() dropdownMessage: string = 'Seleccione';
  @Input() isRequired: boolean = false;


  writeValue(input: any): void {
    this.value.setValue(input);
  }
  propagateChange: any = (f:any) =>{}
  onTouch: any = () => {}

  registerOnChange(fn: any): void {
    this.subscriptions.push(
      this.value.valueChanges.subscribe(fn)
    );
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  registerOnTouched(fn: any){
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
     if (isDisabled) {
      this.value.disable({ emitEvent: false });
    } else {
      this.value.enable({ emitEvent: false });
    }
  }

  isValidField(){
    return utils.isValidFieldForm(this.form!, this.inputName!)
  }
  errorField(){
    return utils.getFieldErrorForm(this.form!, this.inputName!)
  }
}
